import { useHistory } from 'react-router-dom';
export var useHeaderStripDisabledForBrowse = function (isBrowseV2Enabled) {
    var _a, _b;
    var location = useHistory().location;
    return ((_b = (((_a = location === null || location === void 0 ? void 0 : location.pathname) === null || _a === void 0 ? void 0 : _a.includes('browse')) && isBrowseV2Enabled)) !== null && _b !== void 0 ? _b : false);
};
//# sourceMappingURL=useHeaderStripDisabledForBrowse.js.map